module.exports = __webpack_public_path__ + "static/media/realtor-equal.f1a7710e.png";